import GrComponentFactory from "../../gr_component_factory";
import GrPropTypes from "../../shared/gr_prop_types";
import appendQuery from "append-query";
import NonsocialUpdate from "../nonsocial_update";
import UserProfileLink from "../../user/user_profile_link";
import GroupDiscussionNewsfeedItemBody from "./group_discussion_newsfeed_item_body";

const URL_REF_LINK = "discussion_newsfeed_item_link";

export default GrComponentFactory.createClass({
  displayName: "GroupDiscussionNewsfeedItem",

  propTypes: {
    resource: React.PropTypes.shape({
      user: GrPropTypes.user().isRequired,
    }),
    update: React.PropTypes.shape({
      group: GrPropTypes.group().isRequired,
      topic: GrPropTypes.topic().isRequired,
      body: React.PropTypes.shape(GrPropTypes.expandableHtml()),
    }),
  },

  renderHeader() {
    return (
      <div>
        <UserProfileLink user={this.props.resource.user}/>
        {" posted to "}
        <a href={appendQuery(this.props.update.group.url, `ref=${URL_REF_LINK}`)}
            className="gr-hyperlink gr-hyperlink--bold"
            aria-label={`Go to group ${this.props.update.group.name}`}>
            {this.props.update.group.name}
        </a>
      </div>
    );
  },

  renderBody() {
    return (
      <div className="u-marginBottomMedium">
        <GroupDiscussionNewsfeedItemBody {...this.props.update} />
      </div>
    );
  },

  render() {
    return (
      <NonsocialUpdate
        header={this.renderHeader()}
        body={this.renderBody()}
        updateIconUrl={this.props.resource.user.profileImage}
      />);
  },
});
